/* Collapsed OneFit flavour selector for the comprehensive-short template.
   Mirrors the onefit-b shorter behavior (Change My Flavour toggles the grid;
   choosing a flavour updates the collapsed swatch/text + the flavour-detail label).
   Isolated from comprehensive-all-short.js — it only touches the selector UI.

   Load-order guard: this file is loaded with defer from product-onefit-2026.liquid,
   which renders in the body — EARLIER in document order than the deferred
   jquery.min.js in the footer. Deferred scripts run in document order, so the bare
   `jQuery` in the IIFE tail threw ReferenceError and no handler (Change My Flavour,
   buy-box FAQ toggle) ever bound. DOMContentLoaded fires after all deferred
   scripts, so jQuery is guaranteed by then. Do not unwrap. */
document.addEventListener('DOMContentLoaded', function () {
(function ($) {
  "use strict";

  // SKU -> descriptor shown in .flavour-detail (from onefit-b shorter).
  var FLAVOUR_LABELS = {
    'OF-CH-BOX-700-V4.6': '#1 rated Chocolate Milkshake',
    'OF-CM-PCH-700-V4.6': '#1 rated Chocolate Milkshake',
    'OF-TC-BOX-700-V4.6': 'Fruity & Refreshing',
    'OF-TC-PCH-700-V4.6': 'Fruity & Refreshing',
    'OF-VI-BOX-700-V4.6': 'Smooth & Indulgent',
    'OF-VI-PCH-700-V4.6': 'Smooth & Indulgent',
    'OF-FV-BOX-700-V4.6': 'Rich & Creamy',
    'OF-FV-PCH-700-V4.6': 'Rich & Creamy',
    'OF-CO-BOX-700-V4.6': 'Rich & Chocolatey',
    'OF-CO-PCH-700-V4.6': 'Rich & Chocolatey'
  };

  function applyFlavour($flavour) {
    if (!$flavour || !$flavour.length) return;
    var title = $flavour.attr('data-variant-title') || $flavour.find('.title').text();
    var color = $flavour.attr('data-color');
    var sku = $flavour.attr('data-flavour-sku');
    if (color) $('.selector-swatch').css('background', color);
    if (title) $('.selector-text').html($.trim(title));
    if (sku && FLAVOUR_LABELS[sku] !== undefined) $('.flavour-detail').html(FLAVOUR_LABELS[sku]);
  }

  function syncSelected() {
    var $active = $('.flavour-options-wrapper .fon-flavour.active').first();
    if (!$active.length) $active = $('.flavour-options-wrapper .fon-flavour').first();
    applyFlavour($active);
  }

  $(function () {
    syncSelected();

    // Toggle the flavour grid open/closed
    $(document).on('click', '.selector-button', function () {
      $('.flavour-options-wrapper').slideToggle();
    });

    // On flavour choose: update the collapsed swatch/text/detail and close the grid
    $(document).on('click', '.flavour-options-wrapper .fon-flavour', function () {
      applyFlavour($(this));
      $('.flavour-options-wrapper').slideUp();
    });

    // FAQ accordion (mirrors onefit-all-b-shorter.js) — single-open behavior
    $(document).on('click', '.product-info-faq .product-info-list h3', function () {
      var $item = $(this).closest('.product-info-list');
      var isActive = $item.hasClass('active');
      $('.product-info-faq .product-info-list').removeClass('active');
      if (!isActive) $item.addClass('active');
    });
  });
})(jQuery);
});
